export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pro přístup ke všem funkcím vašeho účtu prosím dokončete rychlé ověření totožnosti. Pomáhá nám to zajistit bezpečnost vašeho účtu a dodržovat finanční předpisy."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřit nyní"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Později"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřte svou totožnost"])}
}